import React, { ReactElement, useState } from "react";
import classNames from "classnames";
import styles from "./MobileList.module.scss";
import { ArrowDownIcon } from "@kursk/components/ui/icons";

interface IProps {
  className: string;
  title: string;
  items: string[];
  icon: any;
}

export function MobileList ({ title, items, className, icon }: IProps): ReactElement {
  const [isOpen, toggleIsOpen] = useState(false);

  const toggle = () => {
    toggleIsOpen(!isOpen);
  };
  return (
    <div className={classNames(isOpen && styles.open, styles.button, className)} onClick={toggle}>
      <div className={classNames(isOpen && styles.title_open ,styles.title)}>
        <div className={classNames(styles.icon)}>{icon}</div>
        <div className={styles.name}>
          <div>
            <span className={styles.name_title}>{title}</span>
            <span className={styles.name_count}>{items.length}</span>
          </div>
          <ArrowDownIcon />
        </div>
      </div>
      <div className={classNames(!isOpen && styles.hidden, isOpen && styles.open, styles.dropdownList)}>
        <ul>
          {items.map((item, index) =>
            <li key={index} className={styles.listItem}>{item}</li>
          )}
        </ul>
      </div>
    </div>
  );
}